const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// function preloadImage(url){
//   var img=new Image();
//   img.src=url;
// }
// if(window.innerWidth > 1500){
//   preloadImage("https://www.elitesupps.com.au/cdn/shop/files/GSW-MainBanner-1905x905_1.jpg?v=1713750565&width=1780");
// }else if(window.innerWidth > 1100){
//   preloadImage("https://www.elitesupps.com.au/cdn/shop/files/GSW-MainBanner-1905x905_1.jpg?v=1713750565&width=1500");
// }else if(window.innerWidth > 750){
//   preloadImage("https://www.elitesupps.com.au/cdn/shop/files/GSW-MainBanner-1905x905_1.jpg?v=1713750565&width=1100");
// }else if(window.innerWidth > 550){
//   preloadImage("https://www.elitesupps.com.au/cdn/shop/files/GSW-MainBanner-1905x905_1.jpg?v=1713750565&width=750");
// }else{
//   preloadImage("https://www.elitesupps.com.au/cdn/shop/files/GSW-MainBanner-1905x905_1.jpg?v=1713750565&width=375");
// }